<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formdate from "@/router/views/FormComponet/formdate.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrKontrolTanim from "@/models/StrKontrolTanim";
export default {
  mixins: [Api, Sabit, StrKontrolTanim],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formdate,
    formcombobox,
    formtextarea,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("StrKontrolTanim", this.FormData);
          this.$emit("TableUpdate");
          this.$bvModal.hide("StrKontrolTanim");
        } else {
          this.Update("StrKontrolTanim", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrKontrolTanim");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrKontrolTanim"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrKontrolTanim.AddEdit.FormTitleEdit')
          : $t('StrKontrolTanim.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">  
        <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.SiraNo"
              :Value="FormData.SiraNo"
              :v="$v.FormData.SiraNo"
              @input="FormData.SiraNo = $event"
            />
          </div>

          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.UstDonemId"
              :Value="FormData.UstDonemId"
              :v="$v.FormData.UstDonemId"
              @input="FormData.UstDonemId = $event"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.StandartId"
              :Value="FormData.StandartId"
              :v="$v.FormData.StandartId"
              @input="FormData.StandartId = $event"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.EylemId"
              :Value="FormData.EylemId"
              :v="$v.FormData.EylemId"
              @input="FormData.EylemId = $event"
            />
          </div>
        </div>
        <formdate
          :FormDataType="FormDataType.TamamlanmaTarihi"
          :Value="FormData.TamamlanmaTarihi"
          :v="$v.FormData.TamamlanmaTarihi"
          @input="FormData.TamamlanmaTarihi = $event"
        />
        <div class="row">
          <div class="col-md-6">
            <formtextarea
              :FormDataType="FormDataType.TamamlanmaAciklama"
              :Value="FormData.TamamlanmaAciklama"
              :v="$v.FormData.TamamlanmaAciklama"
              @input="FormData.TamamlanmaAciklama = $event"
            />
          </div>
          <div class="col-md-6">
            <formtextarea
              :FormDataType="FormDataType.Sonuc"
              :Value="FormData.Sonuc"
              :v="$v.FormData.Sonuc"
              @input="FormData.Sonuc = $event"
            />
          </div>
                <div class="col-md-6">
            <formtextarea
              :FormDataType="FormDataType.MevcutDurum"
              :Value="FormData.MevcutDurum"
              :v="$v.FormData.MevcutDurum"
              @input="FormData.MevcutDurum = $event"
            />
          </div>
        </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("StrKontrolTanim.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
